import { BuildInfo } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

export class BuildInfoApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  readBuildInfo(): Promise<BuildInfo> {
    return this.edgeClient.getBuildInfo()
  }
}
